import type { PerfectFor as PerfectForType } from "@shared/graphql.types";
import Image from "next/image";
import { PerfectForText } from "./PerfectForText/PerfectForText";
import * as styles from "./PerfectFor.css";
import { useTrackElementViewed } from "packages/membership/tracking";

type PerfectForProps = {
  perfectFor: PerfectForType;
};

const baseTrackingValues = {
  target: "Perfect For You",
  location: "PDP"
};

export const PerfectFor: React.FC<PerfectForProps> = ({ perfectFor }) => {
  const { ref } = useTrackElementViewed(baseTrackingValues);

  if (!perfectFor.items || !perfectFor.image) return <></>;
  return (
    <section className={styles.wrapper} ref={ref}>
      <PerfectForText items={perfectFor.items} />
      {perfectFor.image.src && (
        <div className={styles.imageWrapper}>
          <Image
            src={perfectFor.image.src}
            alt={perfectFor.image.alt || "Perfect for you"}
            width={470}
            height={470}
          />
        </div>
      )}
    </section>
  );
};
